/**
 * ROBO-846 — no weather on a phone (Herb, 2026-10-29).
 *
 * A phone's calendar day cells leave no room for an icon beside a two-digit date, so a phone gets no weather at all: no
 * request, no icons. "Phone" is the legacy cart's own rule (`base.isPhone` in `View/js/base.js`): the device's SCREEN
 * under 640 px in either dimension. It is the screen, not the window, so a narrowed desktop browser still gets weather,
 * and the two stacks agree on which devices are phones.
 */
export const PHONE_SCREEN_PX = 640;

type ScreenSize = Pick<Screen, 'width' | 'height'>;

/** True on a phone. A screen that reports no size (0 x 0, as jsdom does) is not taken for one. */
export function isPhoneScreen(
    screen: ScreenSize | undefined = typeof window === 'undefined' ? undefined : window.screen
): boolean {
    if (!screen || !(screen.width > 0) || !(screen.height > 0)) {
        return false;
    }
    return screen.width < PHONE_SCREEN_PX || screen.height < PHONE_SCREEN_PX;
}
